module.exports = __webpack_public_path__ + "media/images/applicant/logo-ku-1c30430bd8d254c2d7f032ee2edf70a5.svg";